import React from 'react'
import classNames from 'classnames'
import { DialogOverlay, DialogContent } from '@reach/dialog'

import { CloseButton } from 'library'
import styles from './styles.module.scss'

import '@reach/dialog/styles.css'

const Modal = ({
  children,
  className,
  dismissBtnClassName,
  isOpen,
  handleClose,
  hasNoCloseButton,
  ariaLabel,
  initialFocusRef,
}) => (
  <div>
    <DialogOverlay
      initialFocusRef={initialFocusRef}
      className={styles.overlay}
      isOpen={isOpen}
      onDismiss={() => handleClose && handleClose()}
    >
      <DialogContent
        aria-label={ariaLabel}
        className={classNames(className, styles.content)}
        style={{ boxShadow: '0px 10px 50px hsla(0, 0%, 0%, 0.33)' }}
      >
        {!hasNoCloseButton && (
          <CloseButton
            className={classNames(dismissBtnClassName, styles.dismissBtn)}
            onClick={() => handleClose()}
          />
        )}
        {children}
      </DialogContent>
    </DialogOverlay>
  </div>
)

const ModalTitle = React.forwardRef(({ children, ...props }, ref) => (
  <h1 ref={ref} className={styles.modalTitle} {...props}>
    {children}
  </h1>
))

ModalTitle.displayName = 'ModalTitle'

export { Modal, ModalTitle }
